import { IAdminStore } from "src/stores/adminStore.d";
import AdminApi from "src/api/adminApi";

export class AdminStore implements IAdminStore {
  isLoading: boolean = false;

  async login(username: string, password: string) {
    try {
      this.isLoading = true;
      const res = await AdminApi.login(username, password);
      return res;
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }
}

export default new AdminStore();
